<template>
  <div class="header">
    <v-row justify="space-between" align="center">
      <v-col cols="12" md="6">
        <h1 class="header__title">Finding Our Product has never been easier</h1>
      </v-col>
      <v-col cols="12" md="4">
        <div class="zipcode-block">
          <div class="zipcode-block__label">Zip Code:</div>
          <v-text-field class="zipcode-input" placeholder="Please enter Zip Code" type="number" v-model="currentZipCode"
            hide-details persistent-placeholder @keypress.13.prevent @keyup="changeZipCode"></v-text-field>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'HeaderBlock',
  props: {
    zipcode: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      currentZipCode: '',
    }
  },
  mounted() {
    this.currentZipCode = this.zipcode
  },
  methods: {
    changeZipCode: function (value) {
      if (this.currentZipCode.length > 4) {
        this.$emit('change-zipcode', this.currentZipCode)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: #000;
  padding: 36px 24px;
  margin-bottom: 24px;

  &__title {
    color: #FFF;
    margin: 0;
    line-height: 1.2;
  }
}

.zipcode-block {
  position: relative;

}

.zipcode-block__label {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 12px;
}

.zipcode-input {
  padding: 0;
  margin: 0;
}

::v-deep .zipcode-input .v-input__slot {
  background-color: #FFF;
}

::v-deep .zipcode-input input {
  padding: 12px 12px 12px 90px;
  max-height: none;
}

::v-deep .zipcode-input input::-webkit-outer-spin-button,
::v-deep .zipcode-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

@media (max-width: 768px) {
  .header {
    background-color: #000;
    padding: 24px 18px;
    margin-bottom: 24px;

    &__title {
      font-size: 24px !important;
    }
  }
}
</style>